import { useShortUrls } from './useShortUrls';

export function useShortUrl(longUrl: string): string {
	return useShortUrls({ shortUrl: longUrl }).shortUrl;
}
